import Button from '@atlaskit/button/new';
import ModalDialog, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { Text } from '@atlaskit/primitives/compiled';
import React from 'react';
import { FormattedMessage } from 'react-intl';

type DeleteTeamTypeModalProps = {
	onClose: () => void;
	onDelete: () => void;
	teamTypeName: string;
	teamsCount: number;
	defaultTeamTypeName?: string;
};

export default (props: DeleteTeamTypeModalProps) => {
	const { onClose, onDelete, teamTypeName, teamsCount, defaultTeamTypeName = 'Official' } = props;
	const [isDeleting, setIsDeleting] = React.useState(false);

	return (
		<ModalDialog width="small" onClose={onClose}>
			<ModalHeader hasCloseButton>
				<ModalTitle appearance="danger">
					<FormattedMessage
						id="townsquare.web.teams-settings.delete-team-type-title"
						defaultMessage="Delete team type"
						description="Delete team type modal title"
					/>
				</ModalTitle>
			</ModalHeader>

			<ModalBody>
				<Text>
					{teamsCount > 50 ? (
						<FormattedMessage
							id="townsquare.web.teams-settings.delete-team-type-body-more-than-50"
							defaultMessage="The {teamTypeName} team type is currently used by 50+ teams. Deleting it will change these teams to the {defaultTeamTypeName} team type."
							description="Delete team type modal body over 50 teams"
							values={{
								teamTypeName: <Text weight="bold">{teamTypeName}</Text>,
								defaultTeamTypeName: <Text weight="bold">{defaultTeamTypeName}</Text>,
							}}
						/>
					) : (
						<FormattedMessage
							id="townsquare.web.teams-settings.delete-team-type-body"
							defaultMessage="The {teamTypeName} team type is currently used by {teamsCount, plural, one {# team} other {# teams}}. Deleting it will change these teams to the {defaultTeamTypeName} team type."
							description="Delete team type modal body"
							values={{
								teamTypeName: <Text weight="bold">{teamTypeName}</Text>,
								teamsCount,
								defaultTeamTypeName: <Text weight="bold">{defaultTeamTypeName}</Text>,
							}}
						/>
					)}
				</Text>
			</ModalBody>

			<ModalFooter>
				<Button onClick={onClose} autoFocus appearance="subtle">
					<FormattedMessage
						id="townsquare.web.teams-settings.delete-team-type-cancel"
						defaultMessage="Cancel"
						description="Delete team type modal cancel button"
					/>
				</Button>
				<Button
					onClick={() => {
						setIsDeleting(true);
						onDelete();
					}}
					autoFocus={false}
					appearance="danger"
					isLoading={isDeleting}
				>
					<FormattedMessage
						id="townsquare.web.teams-settings.delete-team-type-confirm"
						defaultMessage="Delete"
						description="Delete team type modal confirm button"
					/>
				</Button>
			</ModalFooter>
		</ModalDialog>
	);
};
